import { atom } from 'recoil';
import { getFirstDateOfEveryMonth } from '../../lib/getPublishedDateList';

const publishedDatesState = atom({
  key: 'publishedDatesState',
  default: getFirstDateOfEveryMonth(),
});

export default publishedDatesState;
